module.exports = __webpack_public_path__ + "media/books/Books-Intro-Teachers-8ddff690.jpg";